import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";
import { relativeTime } from "@/utils/format";

interface LatestNewsProps {
  items: NewsItem[];
}

export default function LatestNews({ items }: LatestNewsProps) {
  return (
    <ul className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((n) => (
        <li key={n.id}>
          <Link
            to={`/news/${n.id}`}
            className="group flex items-start gap-4 p-4 transition-colors hover:bg-background-100"
          >
            <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-20 sm:w-32">
              <img
                src={n.cover}
                alt={`${n.title}配图`}
                title={`${n.title} - 糖心传媒资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800">
                  {n.category}
                </span>
                <span className="text-xs text-foreground-400">{relativeTime(n.publishTime)}</span>
              </div>
              <h3 className="mt-1.5 text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-base">
                {n.title}
              </h3>
              <p className="mt-1 hidden text-xs leading-relaxed text-foreground-600 sm:block">
                {n.lead}
              </p>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}